import { makeStyles } from '@material-ui/core';
import { MDSButton, MDSIcon, MDSTooltip, MDSTypography } from '@marqvision/mds-v2';
import { UseListingNavigationType } from '../../hooks';
import { ArrowLeftIcon } from './ArrowLeftIcon';
import { ArrowRightIcon } from './ArrowRightIcon';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',

    '& button:focus': {
      outline: 'none',
    },
    '& button:focus-visible': {
      outline: 'none',
    },
  },
}));

export const ListingNavigationButton = ({ hasPrev, hasNext, onPrev, onNext }: UseListingNavigationType) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <MDSTooltip
        title={
          <MDSTypography color="color/content/inverse/default/normal">
            Use <ArrowLeftIcon /> on the keyboard
          </MDSTypography>
        }
        position="bottom-center"
      >
        <MDSButton
          size="medium"
          variant="border"
          color="bluegray"
          isDisabled={!hasPrev}
          onClick={onPrev}
          icon={<MDSIcon.TailArrowLeft />}
        />
      </MDSTooltip>
      <MDSTooltip
        title={
          <MDSTypography color="color/content/inverse/default/normal">
            Use <ArrowRightIcon /> on the keyboard
          </MDSTypography>
        }
        position="bottom-center"
      >
        <MDSButton
          size="medium"
          variant="border"
          color="bluegray"
          isDisabled={!hasNext}
          onClick={onNext}
          icon={<MDSIcon.TailArrowRight />}
        />
      </MDSTooltip>
    </div>
  );
};